import React from 'react';
import Step1ContainerMultiFleet from './Step1ContainerMultiFleet';

export const Step1Container = (props) => <Step1ContainerMultiFleet {...props} />;

export default Step1Container;
